import React from "react";
import usePrivateMedia from "../Hook/usePrivateMedia";

const PrivateImage = React.forwardRef(function PrivateImage({ src, alt, as: Component = "img", ...props }, ref) {
  const { url, error } = usePrivateMedia(src);
  if (error) return <span role="status" title={error.message}>{alt || "Image"}: {error.message}</span>;
  if (!url) return <span role="status">Loading image...</span>;
  return <Component {...props} ref={ref} src={url} alt={alt} />;
});

export default PrivateImage;
